import React from 'react';
import './dashboard.scss';
import { isAdmin } from 'utils/isAdmin';
const BarChartVertical = ({ label, value, percentage, color, unit }) => {
  const isAdminRoute = isAdmin() ? '#000' : '#fefefe';
  return (
    <div className="bar-chart-container">
      <p className="unit" style={{ color: isAdminRoute }}>
        {unit}
      </p>
      <div className="bar-chart">
        <div
          className="bar-chart-content"
          style={{ '--percentage': `${percentage}%` }}
        >
          <div className="fill" style={{ backgroundColor: color }}></div>
          <div className="value">{value}</div>
        </div>
      </div>
      <div className="label" style={{ color: isAdminRoute }}>
        {label}
      </div>
    </div>
  );
};

export default BarChartVertical;
